import { Card } from 'primereact/card'
import React from 'react'
import { HrmStatistic } from './HrmStatistic'
import { ObservationStatistic } from './ObservationStatistic'

export interface DataSet {
  data: number[];
  backgroundColor: string[];
  hoverBackgroundColor: string[];
}

export interface LineChartDataSet {
  label: string;
  data: number[];
  fill: boolean;
  borderColor: string;
  tension: number;
}

export interface ChartData {
  labels: string[];
  datasets: DataSet[];
}

export interface LineChartData {
  labels: string[];
  datasets: LineChartDataSet[];
}

export const StatisticModule = () => {
  return (
    <div className={'w-full grid flex-wrap gap-4 pt-2 pb-2 '}>
      <Card className={'w-full p-4 card-hover mokai-gradient-t50'}>
        <HrmStatistic />
      </Card>
      <Card className={'w-full p-4 card-hover  mokai-gradient-t50'}>
        <ObservationStatistic />
      </Card>
    </div>
  )
}